





















import 'vue-awesome/icons/regular/plus-square'
import 'vue-awesome/icons/regular/minus-square'

export default
  name: 'category_row'
  components:
    balance: require('components/inside/elements/balance.vue').default
  props: ['category', 'months_count', 'mode', 'opened']
  computed:
    class_name: ->
      classes = (if @category.sum > 0 then 'incomes' else 'expenses') + '-category-row'
      return classes
    css_styles: ->
      percentage = @category.percentage
      # percentage = 0 if @is_subcategory
      str = "background-size: #{percentage}% 10%; background-position: left bottom;"
      str += 'padding-left: 10px;' if @is_subcategory
      return str
    has_subcategories: -> @category.subcategories || false
    current_page: -> HM.router.currentRoute.name.replace('mobile_', '')
    is_subcategory: -> !_.isEmpty(@category.base_category)
  mounted: ->
    $el = $(@$el)
    $el.hide() if $el.data('base_category')
  methods:
    displayTransactions: ->
      @$store.commit 'TRANSACTIONS/PREVIEW', @category.transaction_ids
    toggleSubcategories: ->
      if @opened then @hideSubcategories() else @showSubcategories()
    showSubcategories: ->
      @$emit 'toggle', @category, true
    hideSubcategories: ->
      @$emit 'toggle', @category, false
